











































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { JAAS_APP } from '../../../jbi-shared/types/jaas-app.types';
import {
  CreateGroupProductRequestPayload,
  UpdateGroupProductRequestPayload
} from '../../../store/modules/admin/types/group-product.types';
import { RootState } from '../../../store/store';
import { StringInputOption } from '../../../jbi-shared/types/form.types';

type ProductFormState = Partial<
  CreateGroupProductRequestPayload | UpdateGroupProductRequestPayload
>;

@Component({
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data(): { form: ProductFormState } {
    const vm = this as Vue & {
      name?: string;
      id?: number;
      applicationId?: JAAS_APP;
    };
    return {
      form: {
        name: vm.name ?? '',
        id: vm.id,
        applicationId: vm.applicationId
      }
    };
  }
})
export default class ProductFormModal extends Vue {
  @Prop(String) name!: string;
  @Prop(Number) id!: number;
  @Prop() applicationId!: JAAS_APP;

  public isSubmitButtonDisabled: boolean = true;

  form!: ProductFormState;

  get applications(): StringInputOption[] {
    return Object.values(JAAS_APP)
      .filter((v) => v !== JAAS_APP.cplus && v !== JAAS_APP.myjbi)
      .map((v) => ({
        id: v,
        name: v?.toUpperCase()
      }));
  }

  get loading() {
    return (
      (this.$store?.state as RootState).admin.apiState.createGroupProduct
        .loading ||
      (this.$store?.state as RootState).admin.apiState.updateGroupProduct
        .loading
    );
  }

  get editing() {
    return this.id;
  }

  @Watch('form.name')
  @Watch('form.applicationId')
  public watchFormValues() {
    this.isSubmitButtonDisabled = !(this.form.name && this.form.applicationId);
  }

  public mounted() {
    this.watchFormValues();
  }
}
